import {gql} from 'apollo-boost';

export const SYSTEM_CONFIG_WESTERN = gql`
  query systemConfigWestern{
    systemConfigWestern {
      id universityName welcomeMessage contactInfo
      fullWelcomePictureMobile
    }
  }
`;

export const SYSTEM_CONFIG_NATION = gql`
  query systemConfigNation{
    systemConfigNation {
      id universityName welcomeMessage contactInfo
      fullWelcomePictureMobile
    }
  }
`;

export const SYSTEM_CONFIG = gql`
  query systemConfig{
    systemConfig {
      id universityName logoMobile logoTablet logoDesktop
      welcomePictureMobile welcomePictureTablet welcomePictureDesktop welcomeMessage contactInfo
    }
  }
`;

export const ADD_SYSTEM_CONFIG = gql`
  mutation addSystemConfig(
    $systemConfigInput: SystemConfigInput,
  ) {
    addSystemConfig(
      systemConfigInput: $systemConfigInput
    ) {
      id universityName logoMobile logoTablet logoDesktop
      welcomePictureMobile welcomePictureTablet welcomePictureDesktop welcomeMessage contactInfo
    }
  }
`;

export const UPDATE_SYSTEM_CONFIG = gql`
  mutation updateSystemConfig(
    $id: ID!,
    $systemConfigInput: SystemConfigInput!
  ) {
    updateSystemConfig(
      id: $id
      systemConfigInput: $systemConfigInput
    ) {
      id universityName logoMobile logoTablet logoDesktop
      welcomePictureMobile welcomePictureTablet welcomePictureDesktop welcomeMessage contactInfo
    }
  }
`;


